module.exports = __webpack_public_path__ + "img/Jakarta_s Future in Sustainable Housing.75ea77f7.png";